export type ConfiguracionPrecios = {
  precioIndividualCentavos: number;
  precioPaqueteCentavos: number;
  precioLotusIndividualCentavos: number;
  precioLotusPaqueteCentavos: number;
};

export function calcularPrecioLista(
  individuales: number,
  paquetes: number,
  cantidadLotus: number,
  precios: ConfiguracionPrecios,
) {
  const individualesValidos = Math.max(0, Math.trunc(individuales));
  const paquetesValidos = Math.max(0, Math.trunc(paquetes));
  const piezas = individualesValidos + paquetesValidos * 3;
  const lotus = Math.min(piezas, Math.max(0, Math.trunc(cantidadLotus)));
  const minimoLotusEnPaquetes = Math.max(0, lotus - individualesValidos);
  const maximoLotusEnPaquetes = Math.min(lotus, paquetesValidos * 3);
  let mejorPrecio = Number.POSITIVE_INFINITY;

  for (let lotusEnPaquetes = minimoLotusEnPaquetes; lotusEnPaquetes <= maximoLotusEnPaquetes; lotusEnPaquetes += 1) {
    const lotusIndividuales = lotus - lotusEnPaquetes;
    const clasicasIndividuales = individualesValidos - lotusIndividuales;
    if (clasicasIndividuales < 0) continue;

    const paquetesLotusCompletos = Math.floor(lotusEnPaquetes / 3);
    const lotusRestantes = lotusEnPaquetes % 3;
    const paquetesMixtos = lotusRestantes > 0 ? 1 : 0;
    const paquetesClasicos = paquetesValidos - paquetesLotusCompletos - paquetesMixtos;
    if (paquetesClasicos < 0) continue;

    const precioMixto = lotusRestantes * precios.precioLotusIndividualCentavos
      + (3 - lotusRestantes) * precios.precioIndividualCentavos;
    const precio = lotusIndividuales * precios.precioLotusIndividualCentavos
      + clasicasIndividuales * precios.precioIndividualCentavos
      + paquetesLotusCompletos * precios.precioLotusPaqueteCentavos
      + paquetesMixtos * precioMixto
      + paquetesClasicos * precios.precioPaqueteCentavos;
    mejorPrecio = Math.min(mejorPrecio, precio);
  }

  return Number.isFinite(mejorPrecio)
    ? mejorPrecio
    : individualesValidos * precios.precioIndividualCentavos + paquetesValidos * precios.precioPaqueteCentavos;
}
